export default __webpack_public_path__ + "static/Lets-talk-copy-8d7b1b5ec2b0708089da9b23b6285640.webp";